import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { TrailCamHistorySection } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/trailcam/TrailCamHistorySection';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { TrailCamHistorySectionSkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/trailcam/TrailCamHistorySectionSkeleton';

export function TrailCamContent() {
    return (
        <ContentBox.Section heading="History" disableDivider>
            <SuspenseWrapper loadingComponent={<TrailCamHistorySectionSkeleton />}>
                <TrailCamHistorySection />
            </SuspenseWrapper>
        </ContentBox.Section>
    );
}
